import React from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'

import MainTitle from '../components/MainTitle'
import WorkForm from '../components/WorkForm'

const TrabalheConosco = ({ data }) => (
  <Layout>
    <SEO title="Fale Conosco" />

    <MainTitle
        content={ `<h1>Trabalhe <em>conosco</em></h1><p>Cadastre seu currículo para 
        trabalhar com a Reinserir ou com algum parceiro</p>`} />

    <WorkForm />

  </Layout>
)

export default TrabalheConosco
